module.exports = __webpack_public_path__ + "static/media/putting_sugary_snacks_and_drinks_into_your_mouth.47a4ccc.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/audio/putting_sugary_snacks_and_drinks_into_your_mouth.mp3
// module id = 02ft
// module chunks = 0